function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgRevision = function SvgRevision(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 48 48",
    style: {
      enableBackground: "new 0 0 48 48"
    },
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FBA7A1"
    },
    points: "36,5 32,9 28,5 24,9 20,5 16,9 12,5 8,9 4,5 4,36.5 36,36.5 "
  }), /*#__PURE__*/React.createElement("rect", {
    x: 10,
    y: 14,
    style: {
      fill: "#E72F17"
    },
    width: 12,
    height: 2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 25,
    y: 14,
    style: {
      fill: "#E72F17"
    },
    width: 5,
    height: 2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 10,
    y: 18,
    style: {
      fill: "#E72F17"
    },
    width: 6,
    height: 2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 19,
    y: 18,
    style: {
      fill: "#E72F17"
    },
    width: 11,
    height: 2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 10,
    y: 22,
    style: {
      fill: "#E72F17"
    },
    width: 4,
    height: 2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 17,
    y: 22,
    style: {
      fill: "#E72F17"
    },
    width: 6,
    height: 2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 26,
    y: 22,
    style: {
      fill: "#E72F17"
    },
    width: 4,
    height: 2
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FCD0CD"
    },
    d: "M38.522,30h-29L9.478,43c0,0,27.579-0.004,29,0c3.038,0.009,5.51-2.894,5.522-6.483  S41.559,30.009,38.522,30z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 10,
    y: 26,
    style: {
      fill: "#E72F17"
    },
    width: 10,
    height: 2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 22,
    y: 26,
    style: {
      fill: "#E72F17"
    },
    width: 8,
    height: 2
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F9756C"
    },
    d: "M9.522,30C6.484,29.991,4.012,32.894,4,36.483C3.988,40.073,6.441,42.991,9.478,43  s5.51-2.894,5.522-6.483S12.559,30.009,9.522,30z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E75B32"
    },
    d: "M9.509,33C8.33,33,7.008,34.492,7,36.493c-0.004,1.042,0.351,2.035,0.973,2.725  c0.264,0.291,0.81,0.78,1.514,0.782c0.002,0,0.003,0,0.004,0c1.178,0,2.501-1.492,2.509-3.493c0.007-2.003-1.307-3.504-2.487-3.507  C9.511,33,9.51,33,9.509,33z"
  }));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgRevision, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/revision.3195ca7d.svg";
export { ForwardRef as ReactComponent };